import { useState } from "react";
import {
  Box,
  FormControlLabel,
  Radio,
  Typography,
  RadioGroup,
} from "@mui/material";

type Props = {
  currentBlock: any;
};

const RadioFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const choices = currentBlock?.config?.choices || [];

  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Box>
      {label && (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "regular",
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
      )}

      <RadioGroup value={selectedValue} onChange={handleChange}>
        {choices.map((choice: any) => (
          <FormControlLabel
            key={choice.key}
            control={<Radio />}
            label={choice.label}
            value={choice.key}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                fontWeight: "medium",
              },
            }}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default RadioFieldPreview;
